import * as React from 'react';

import styled, { css } from 'styled-components';

import ActionButton, { ActionButtonSizes, IActionButtonProps } from 'components/action-button';

export interface FabProps extends IActionButtonProps {
  caption?: string;
  badge?: string | number | undefined;
}

const FabContainer = styled.div<{
  $badgeContent?: string | number | undefined;
}>`
  position: absolute;
  right: -0.625rem;
  bottom: 0;
  padding-right: 1.125rem;
  padding-bottom: 1.75rem;
  ${({ $badgeContent }) =>
    $badgeContent &&
    css`
      ::after {
        background: ${Styles.color.contrastBackground};
        color: ${Styles.color.white};
        border-radius: ${Styles.borderRadius};
        content: '${$badgeContent}';
        font-family:${Styles.fontFamily.base};
        font-size: 0.725rem;
        height: 1.125rem;
        position: absolute;
        right: 1rem;
        text-align: center;
        top: -0.5rem;
        width: 1.125rem;
      }
    `}
`;

const StyledActionButton = styled(ActionButton)`
  background-color: ${Styles.color.primary};
  font-size: 16px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  &:hover {
    background-color: ${Styles.color.primaryHover};
  }
`;

export const Fab: React.FC<FabProps> = ({
  size = ActionButtonSizes.LARGE,
  caption,
  badge,
  onClick,
  ...rest
}) => (
  <FabContainer $badgeContent={badge}>
    <StyledActionButton size={size} onClick={onClick} {...rest}>
      {caption}
    </StyledActionButton>
  </FabContainer>
);
